import { AlignSelfType, PaddingType } from 'common/types/styleTypes'
import {
  backgroundColorCss,
  borderCss,
  boxShadowCss,
  FontProps,
  fontCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobileFontCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import styled, { css } from 'styled-components'

type AttachmentsUiProps = BorderEntityInterface & {
  alignSelf?: AlignSelfType
  mobileAlignSelf?: AlignSelfType
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  backgroundColor: string
  mobileBackgroundColor?: string
  boxShadow?: string
  mobileBoxShadow?: string
} & FontProps

const AttachmentsUi = styled.div<AttachmentsUiProps>`
  cursor: pointer;
  width: auto;
  align-self: ${p => p.alignSelf || 'center'};
  ${backgroundColorCss}
  ${paddingsCss}
  ${fontCss}
  ${borderCss}
  ${boxShadowCss}
  ${p => p.theme.phone} {
    align-self: ${p => p.mobileAlignSelf || 'center'};
    ${mobileBackgroundColorCss}
    ${mobilePaddingsCss}
    ${mobileFontCss}
    ${mobileBorderCss};
    ${mobileBoxShadowCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBackgroundColorCss}
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileFontCss}
      ${mobileBorderCss};
      ${mobileBoxShadowCss}
      align-self: ${p.mobileAlignSelf || 'center'};
    `}
`

export default AttachmentsUi
